import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listarFabricantes = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/veiculo-fabricante/listar-ativos-simples',
    config
  )
  return response.data
}

export default {
  listarFabricantes
}



// WEBPACK FOOTER //
// ./src/actions/VeiculoActions.js